import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material';
import { AppStateService } from '../../../services/app-state.service';
import { ImageUtilsService } from '../../../services/image-utils.service';
import { BuildFloorService } from '../../../services/build-floor.service';

@Component({
  selector: 'app-modal-settings',
  templateUrl: './modal-settings.component.html',
  styleUrls: ['./modal-settings.component.scss']
})
export class ModalSettingsComponent implements OnInit {

  constructor(
    public dialogRef: MatDialogRef<ModalSettingsComponent>,
    private appStateService: AppStateService,
    private imageUtilsService: ImageUtilsService,
    private buildFloorService: BuildFloorService
  ) { }

  public sizeUnits: string;

  closeDialog() {
    this.dialogRef.close();
  }

  toggleSizeUnits(value): void {
    this.sizeUnits = value;
    this.appStateService.sizeUnits = value;
    this.imageUtilsService.drawTextSprites();
  }

  ngOnInit() {
    this.sizeUnits = this.appStateService.sizeUnits;
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/modals/modal-settings/modal-settings.component.ts